var exports = {
  "kL": "StatusSlate.module__container___cnk2cG",
  "Nb": "StatusSlate.module__fullHeight___cnk2cG",
  "Kk": "StatusSlate.module__icon___cnk2cG",
  "DD": "StatusSlate.module__title___cnk2cG",
  "h_": "StatusSlate.module__description___cnk2cG",
  "o1": "StatusSlate.module__actions___cnk2cG",
};

module.exports = exports;
